import { type RcFile } from 'antd/es/upload'
import { type FC } from 'react'

import { Alert } from '@/components/elements'
import {
  ACTIONS,
  DESCRIPTIONS,
  SHIPMENT_ORDER_CSV_IMPORT
} from '@/constants/common/message.constants'
import { FileUploadDragger } from '@/features/uploads/components'
import { type UploadFileResult } from '@/features/uploads/models'
import { validateCsvFile } from '@/utils/upload-file-validator'

type Props = {
  onChangeUploadFile: (result: UploadFileResult | null) => void
  /** 選んだファイルの本体（修正を反映した CSV を元の CSV と同じ形で書き出すときに読む） */
  onSelectFile: (file: File) => void
}

/**
 * サントリー様の CSV のファイル選択。既存の取り込み画面と同じドロップ欄で、選ぶと一時領域へアップロードする
 * （中身は画面では読まず、次の確認画面で事前チェック API が読む）。
 */
export const SuntoryFileView: FC<Props> = ({
  onChangeUploadFile,
  onSelectFile
}) => (
  <div
    className="flex flex-col gap-3"
    data-testid="shipment-order-csv-import__suntory-file"
  >
    <Alert title={SHIPMENT_ORDER_CSV_IMPORT.SUNTORY_FILE_ALERT_MESSAGE}>
      <span className="text-xs">
        {SHIPMENT_ORDER_CSV_IMPORT.SUNTORY_FILE_ALERT_DESCRIPTION}
      </span>
    </Alert>
    <FileUploadDragger
      title={ACTIONS.UPLOAD_SHIPMENT_ORDER}
      description={`${DESCRIPTIONS.CSV_FILE_UPLOAD}${DESCRIPTIONS.PLEASE}`}
      isValidFile={(file: RcFile) => {
        // validateCsvFile は問題が無ければ null、あればエラーメッセージを返す
        const errorMessage = validateCsvFile(file)
        if (errorMessage === null) onSelectFile(file)
        return errorMessage
      }}
      onChangeUploadFile={onChangeUploadFile}
    />
  </div>
)
